import { CommonModule, Location } from '@angular/common';
import { Component, inject, model, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';
import { TextoPrincipalPlanesComponent } from '../../../components/texto-principal-planes/texto-principal-planes.component';
import { getVehicleData } from '../../../helpers/dataLayerHelpers';
import { getFromStorage, getSessionId } from '../../../helpers/storageUtils';
import { CreateLead } from '../../../Models/createLead';
import { DatosGenerales } from '../../../Models/datosGenerales';
import { DatosPlanes } from '../../../Models/datosPlanes';
import { ExceptionRequest } from '../../../Models/exceptionRequest';
import { LeadResponse } from '../../../Models/leadResponse';
import { PipesModule } from '../../../pipes/pipes.module';
import { DataLayerService } from '../../../services/DataLayer/data-layer.service';
import { ExceptionService } from '../../../services/excepciones/exception.service';
import { InactivityService } from '../../../services/inactivity/inactivity.service';
import { LeadsService } from '../../../services/Leads/leads.service';
import { UtilsService } from '../../../services/utils.service';
import { InspectionBannerComponent } from '../../../shared/components/inspection-banner/inspection-banner.component';
import { selectData } from '../../../storage/Lead/data.selectors';
import { selectPlanes } from '../../../storage/Planes/planes.selector';
import { CardPlanesComponent } from '../card-planes/card-planes.component';
import { StepperComponent } from '../stepper/stepper.component';

@Component({
  selector: 'app-planes',
  standalone: true,
  imports: [
    BannerAppComponent,
    StepperComponent,
    FooterAppComponent,
    TextoPrincipalPlanesComponent,
    CardPlanesComponent,
    CommonModule,
    PipesModule,
    InspectionBannerComponent,
  ],
  templateUrl: './planes.component.html',
  styleUrl: './planes.component.scss',
})
export class PlanesComponent implements OnInit, OnDestroy {
  //inyección de dependencias
  router = inject(Router);
  utils = inject(UtilsService);
  exceptionService = inject(ExceptionService);
  private inactivityService = inject(InactivityService);

  nombreTextoPrincipal = '';
  textoInferior = '';
  codigoAsesor: string | undefined;
  completo = '';
  sessionId = '';

  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;
  public datosPlanes: DatosPlanes | null = null;
  datosPlanes$: Observable<DatosPlanes | null>;
  leadResponse: LeadResponse | null = null;

  formulario: FormGroup = new FormGroup({});

  datosLead: CreateLead = {
    plate: '',
    confirm_plate: '',
    owner_borndate: '',
    circulation_zone_id: '',
    use_type: '',
    accept_tos: false,
    name: '',
    mobile_phone: '',
    assessor_code: 0,
  };

  envio: ExceptionRequest = {
    percentege_lead: '',
    required_status: '',
  };
  leadId = '';

  private inactivityTimer: any;
  private readonly INACTIVITY_TIMEOUT = environment.LOCAL_TIMER;
  hidePaymentCheck = model<boolean>(false);
  vehiclePlusAccesoriesValue = getFromStorage('vehiclePlusAccesoriesValue', 'session') ?? null;

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private leadServices: LeadsService,
    private location: Location,
    private dataLayerService: DataLayerService,
  ) {
    this.datosGenerales$ = this.store.select(selectData);
    this.datosPlanes$ = this.store.select(selectPlanes);
  }

  ngOnInit(): void {
    this.inactivityService.stopTimer();
    this.inactivityService.startDefaultTimerForScreen('Planes', 'Abandono Planes', '50');

    const Onlyannualplan = getFromStorage<boolean>('Onlyannualplan', 'session') ?? false;

    if (Onlyannualplan) {
      this.hidePaymentCheck.set(true);
    }

    this.sessionId = getSessionId().toString();
    const currentUrl = this.location.path();
    console.log('URL: ACTUAL: ', currentUrl);

    // Get codigoAsesor from query parameters
    this.route.queryParams.subscribe((params) => {
      this.codigoAsesor = params['codigoAsesor'] || '';
      console.log('Código Asesor en Planes:', this.codigoAsesor);
    });

    // this.tiempoInactivo.startMonitoring('50', 'Abandono_Resumen_Planes', currentUrl);

    this.datosGenerales$.subscribe((data) => {
      this.datosGenerales = data;
    });

    this.datosPlanes$.subscribe((data) => {
      this.datosPlanes = data;
      console.log('Planes data:', data);
    });

    this.completo = this.datosGenerales?.LeadResponse.data.vehicle.owner.firstnames ?? '';
    if (this.completo !== '') {
      this.nombreTextoPrincipal = this.completo + ', estos son los planes que tenemos para ti';
      this.textoInferior = '';
    } else {
      this.nombreTextoPrincipal = 'Nombre, ya están listas tus opciones';
      this.textoInferior = 'elige un plan para tu moto';
    }

    this.dataLayerService.pushDataLayer({
      event: 'moto_ecommerce_step_3_planes',
      ecom_tipo: 'Moto',
      ecom_item: 'Pageview',
      ecom_pantalla: 'Planes',
      user_id: this.sessionId,
      ...getVehicleData(this.datosGenerales),
      plan_seleccionado: undefined,
    });
  }

  swMensual = false;
  swAnual = true;
  tipoPagoPlan = '';

  radioChangeHandler(event: any) {
    if (event.target.value === 'Anual') {
      this.swAnual = true;
      this.swMensual = false;
    } else {
      this.swAnual = false;
      this.swMensual = true;
    }
  }

  ngOnDestroy() {
    this.inactivityService.stopTimer();
  }
}
